export const gtmEventTypes = {
  CLICK_SPECS_CTA: 'FED-MYMAZDA-003',
}

export const gtmEvents = {
  [gtmEventTypes.CLICK_SPECS_CTA]: ({ctaName}) => ({
    type: gtmEventTypes.CLICK_SPECS_CTA,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SPECS_CTA,
    pageCategory: 'MyMazda',
    pageAction: `MyMazda Home - Specifications - Clicked "${ctaName.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/mymazda-summary-duck.js